var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLightInjection(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 20 20",
    enableBackground: "new 0 0 20 20",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    points: " 5.606,0.793 5.606,10.732 8.198,10.732 8.198,19.193  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.733,
    y: 10.732,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    width: 1.465,
    height: 2.747
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4.004,
    y: 5.375,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    width: 1.602,
    height: 5.357
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    points: " 14.394,0.807 14.394,10.746 11.802,10.746 11.802,19.207  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.802,
    y: 10.746,
    transform: "matrix(-1 -4.531054e-11 4.531054e-11 -1 25.0696 24.2394)",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    width: 1.465,
    height: 2.747
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.394,
    y: 5.389,
    transform: "matrix(-1 -4.486201e-11 4.486201e-11 -1 30.3898 16.1353)",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    width: 1.602,
    height: 5.357
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightInjection);
export default __webpack_public_path__ + "static/media/light-injection.1d784c7c2d28f6867d0c94acb482d77f.svg";
export { ForwardRef as ReactComponent };